import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    marginBottom: theme.spacing(-4),
    overflowX: 'hidden',
    background: 'linear-gradient(248deg, #DC1866 0%, #FF9226 100%) 0% 0% no-repeat',

    '&::after': {
      display: 'block',
      left: 0,
      bottom: 0,
      content: '""',
      position: 'absolute',
      borderTop: '50px solid transparent',
    },
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
    color: theme.palette.common.white,

    '& img': {
      maxWidth: '100%',
      maxHeight: '100%',
      marginTop: theme.spacing(4),
    },

    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
      justifyContent: 'space-evenly',
      textAlign: 'left',

      '& img': {
        marginTop: 0,
      },
    },
  },
  videoWrapper: {
    zIndex: 1,
  },
  video: {
    width: '90%',
    marginTop: theme.spacing(4),
    borderRadius: theme.spacing(1.5),

    [theme.breakpoints.up('md')]: {
      width: 650,
      marginTop: 0,
      zIndex: 2,
    },
  },
  optionsHeader: {
    fontSize: 18,
    '& img': {
      paddingRight: 13,
    },
  },
  button: {
    marginTop: theme.spacing(4),
    padding: theme.spacing(1.5, 3),
    textTransform: 'none',
    fontWeight: theme.typography.fontWeightBold,
    borderRadius: 40,
    backgroundColor: '#7833FF',

    '&:hover': {
      backgroundColor: '#5F29CC',
    },
  },
}));
